// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voyage-port-call-container {
    max-width: 900px;
    padding: 0.5rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    font-family: Arial, sans-serif;
}

.section {
    margin-bottom: 2rem;
    border: 1px solid #577481;
    border-radius: 6px;
    padding: 2rem;
    background: #fff;
}

    .section h3 {
        color: #2c3e50;
        margin-bottom: 0.25rem;
    }

    .section p {
        font-size: 0.85rem;
        color: #555;
        margin-top: 0;
        margin-bottom: 0.75rem;
    }

.search-input {
    width: 100%;
    padding: 8px 12px;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.dropdown-results {
    border: 1px solid #ccc;
    max-height: 200px;
    overflow-y: auto;
    margin-top: 0.5rem;
    border-radius: 4px;
    background: white;
    list-style: none;
    padding-left: 0;
}

    .dropdown-results li {
        padding: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
    }

        .dropdown-results li:hover {
            background-color: #d7eaff;
        }

.flag-icon {
    width: 24px;
    height: 16px;
    object-fit: contain;
    border: 1px solid #ccc;
    border-radius: 3px;
}

.datetime-group {
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-top: 0.5rem;
}

    .datetime-group label {
        font-weight: 600;
        color: #2c3e50;
    }

    .datetime-group input {
        padding: 6px;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid #aaa;
        width: 160px;
    }

label {
    font-weight: 600;
    display: block;
    margin-top: 1rem;
}

input[type="text"],
input[type="datetime-local"] {
    width: 100%;
    padding: 6px;
    border-radius: 5px;
    border: 1px solid #ccc;
    margin-top: 0.25rem;
}

.error-box {
    background: #f8d7da;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 1rem;
}

.error-text {
    color: #721c24;
    margin: 0;
    font-weight: 600;
}

.submit-button {
    background-color: #0061b0;
    color: white;
    padding: 12px 24px;
    font-size: 1.1rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 700;
    display: block;
    margin: 0 auto;
    transition: background-color 0.3s ease;
}

    .submit-button:hover {
        background-color: #004880;
    }
.ship-details {
    background: #f0f4f8;
    padding: 1rem;
    border-radius: 6px;
    margin-bottom: 1rem;
    border: 1px solid #a0b7c4;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    font-size: 0.95rem;
    color: #2c3e50;
    font-weight: 600;
}
.flag-icon {
    width: 24px;
    height: 16px;
    object-fit: contain;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin-right: 8px;
    vertical-align: middle;
}

.error-box {
    background: #f8d7da;
    padding: 10px;
    border-radius: 5px;
    margin-top: 1rem;
    color: #721c24;
    font-weight: 600;
}

.error-text {
    margin: 0;
    margin-bottom: 4px;
}
.success-box {
    background: #d4edda;
    color: #155724;
    padding: 10px;
    border-radius: 5px;
    margin-top: 1rem;
    font-weight: 600;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/Voyages/VoyagesStep.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;IAEI;QACI,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,sBAAsB;IAC1B;;AAEJ;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,YAAY;QACZ,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,QAAQ;IACZ;;QAEI;YACI,yBAAyB;QAC7B;;AAER;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,sBAAsB;QACtB,YAAY;IAChB;;AAEJ;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,sCAAsC;AAC1C;;IAEI;QACI,yBAAyB;IAC7B;AACJ;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".voyage-port-call-container {\n    max-width: 900px;\n    padding: 0.5rem;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n    font-family: Arial, sans-serif;\n}\n\n.section {\n    margin-bottom: 2rem;\n    border: 1px solid #577481;\n    border-radius: 6px;\n    padding: 2rem;\n    background: #fff;\n}\n\n    .section h3 {\n        color: #2c3e50;\n        margin-bottom: 0.25rem;\n    }\n\n    .section p {\n        font-size: 0.85rem;\n        color: #555;\n        margin-top: 0;\n        margin-bottom: 0.75rem;\n    }\n\n.search-input {\n    width: 100%;\n    padding: 8px 12px;\n    font-size: 1rem;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n\n.dropdown-results {\n    border: 1px solid #ccc;\n    max-height: 200px;\n    overflow-y: auto;\n    margin-top: 0.5rem;\n    border-radius: 4px;\n    background: white;\n    list-style: none;\n    padding-left: 0;\n}\n\n    .dropdown-results li {\n        padding: 8px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    }\n\n        .dropdown-results li:hover {\n            background-color: #d7eaff;\n        }\n\n.flag-icon {\n    width: 24px;\n    height: 16px;\n    object-fit: contain;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n}\n\n.datetime-group {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    margin-top: 0.5rem;\n}\n\n    .datetime-group label {\n        font-weight: 600;\n        color: #2c3e50;\n    }\n\n    .datetime-group input {\n        padding: 6px;\n        font-size: 1rem;\n        border-radius: 5px;\n        border: 1px solid #aaa;\n        width: 160px;\n    }\n\nlabel {\n    font-weight: 600;\n    display: block;\n    margin-top: 1rem;\n}\n\ninput[type=\"text\"],\ninput[type=\"datetime-local\"] {\n    width: 100%;\n    padding: 6px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    margin-top: 0.25rem;\n}\n\n.error-box {\n    background: #f8d7da;\n    padding: 10px;\n    border-radius: 5px;\n    margin-bottom: 1rem;\n}\n\n.error-text {\n    color: #721c24;\n    margin: 0;\n    font-weight: 600;\n}\n\n.submit-button {\n    background-color: #0061b0;\n    color: white;\n    padding: 12px 24px;\n    font-size: 1.1rem;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 700;\n    display: block;\n    margin: 0 auto;\n    transition: background-color 0.3s ease;\n}\n\n    .submit-button:hover {\n        background-color: #004880;\n    }\n.ship-details {\n    background: #f0f4f8;\n    padding: 1rem;\n    border-radius: 6px;\n    margin-bottom: 1rem;\n    border: 1px solid #a0b7c4;\n}\n\n.details-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 10px;\n    font-size: 0.95rem;\n    color: #2c3e50;\n    font-weight: 600;\n}\n.flag-icon {\n    width: 24px;\n    height: 16px;\n    object-fit: contain;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    margin-right: 8px;\n    vertical-align: middle;\n}\n\n.error-box {\n    background: #f8d7da;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 1rem;\n    color: #721c24;\n    font-weight: 600;\n}\n\n.error-text {\n    margin: 0;\n    margin-bottom: 4px;\n}\n.success-box {\n    background: #d4edda;\n    color: #155724;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 1rem;\n    font-weight: 600;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
